import { EditOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { gridDetailPanelExpandedRowIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro'

export interface GridActionCellProps {
  params: GridRenderCellParams
  onEdit: () => void
}
export const GridActionCell = ({ params, onEdit }: GridActionCellProps) => {
  const apiRef = useGridApiContext()
  const expandedRowIds = useGridSelector(apiRef, gridDetailPanelExpandedRowIdsSelector)
  const isExpanded = expandedRowIds.has(params.id)

  // Hide pencil icon when panel is expanded
  if (isExpanded) {
    return null
  }

  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation()
        onEdit()
        apiRef.current.toggleDetailPanel(params.id)
      }}
    >
      <EditOutlined fontSize="small" />
    </IconButton>
  )
}
